import { useQuery, useQueryClient, QueryOptions, QueryResult } from '@eika-infrastruktur/react-query';

import type { RecurringPaymentAgreement } from '../generated-types';
import { getRecurringPayments } from '../services/recurringPaymentsService';

const RECURRING_PAYMENTS_QUERY_KEY = ['recurringPayments'];

export const useRecurringPayments = (
    options: Partial<QueryOptions<RecurringPaymentAgreement[]>> = {},
): QueryResult<RecurringPaymentAgreement[]> =>
    useQuery({ ...options, queryKey: RECURRING_PAYMENTS_QUERY_KEY, queryFn: getRecurringPayments });

export const useRefreshRecurringPayments = () => {
    const queryClient = useQueryClient();
    return () => queryClient.invalidateQueries({ queryKey: RECURRING_PAYMENTS_QUERY_KEY });
};
